import Footer from "../../components/main/Footer"
import { Header } from '../../components/organisms/Header'
import { Topbar } from "../../components/organisms/Topbar"
import Basket from "../../components/organisms/Basket"
import { initPdiComponent } from "../../core/service/BusinessLogicService"
import React, { useEffect } from "react"
import { Col, Container, Row } from "react-bootstrap"

export const withLayout = (WrappedPage, serviceDisplay, page) => {
  return (props) => {
    const { tunnelData, history } = props

    useEffect(() => {
      initPdiComponent(page)
    }, [])

    return (
      <Container fluid className="white-background">
        <Row noGutters>
          <Col className="main-block">
            <Row>
              <Topbar tunnelData={tunnelData} history={history} />
              <Header tunnelData={tunnelData} />
              <Col sm={12}>
                <Container>
                  <WrappedPage {...props} />
                </Container>
              </Col>
              <Col sm={12}>
                <Container>
                  <Footer tunnelData={tunnelData} serviceDisplay={serviceDisplay} />
                </Container>
              </Col>
            </Row>
          </Col>
          <Col className="aside-block d-none d-lg-block d-xl-block" lg={4}>
            <Basket tunnelData={tunnelData} />
          </Col>
        </Row>
      </Container>
    )
  }
}
